import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface CustomPortalProps {
  wrapperId: string;
  children: React.ReactNode;
}

const CustomPortal = ({ wrapperId, children }: CustomPortalProps) => {
  const [wrapperElement, setWrapperElement] =
    React.useState<HTMLDivElement | null>(null);

  React.useLayoutEffect(() => {
    let element = document.getElementById(wrapperId) as HTMLDivElement;
    let systemCreated = false;
    if (!element) {
      systemCreated = true;
      const wrapperElement = document.createElement('div');
      wrapperElement.setAttribute('id', wrapperId);
      document.body.appendChild(wrapperElement);
      element = wrapperElement;
    }
    setWrapperElement(element);

    return () => {
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  if (wrapperElement === null) return null;

  return ReactDOM.createPortal(children, wrapperElement);
};

export { CustomPortal };
